import { Injectable, inject } from '@angular/core';
import { HttpRequest, HttpHandler, HttpInterceptor, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { StorageService } from '../services/storage.service';

/**
 * Intercepteur HTTP
 * injectable
 */
@Injectable({ providedIn: 'root' })
/**
 * UuidInterceptorService
 * @class
 * @implements {HttpInterceptor}
 */
export class UuidInterceptorService implements HttpInterceptor {
  /**
   * inject the strorage service
   * @param {StorageService} storageService
   */
  private storageService = inject(StorageService);


  /**
   * Intercepts the HTTP request and adds the X-MYCENA-Unicorn-Guid header
   * with the session uuid if it exists
   * @param {HttpRequest<any>} req - The HTTP request
   * @param {HttpHandler} next - The HTTP handler
   * @returns The observable of the http event
   */
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const uuid = this.storageService.getSessionUUID();
    if (uuid) {
      req = req.clone({
        setHeaders: {
          'X-MYCENA-Unicorn-Guid': uuid
        },
      });
      return next.handle(req);
    } else {
      return next.handle(req);
    }
  }
}

